import styled from "styled-components";
import { COLORS } from "../../styles/constants.style";

export const MuiDoubleLabelHorizontalWrapper = styled.div`
  display: flex;
  align-items: center;

  .MuiBox-root {
    padding: 0;
  }

  .value-container {
    padding: 4px 10px;
    margin-left: 8px;
    background-color: ${COLORS.cirrus_black2};
    border-radius: 4px;
  }
`;
